import { Helmet } from 'react-helmet';
import { config } from 'config';

type Props = {
  image?: string;
};

const defaultImage = `${config.ENV.ORIGIN_URL}/static/logo.svg`;

export const MetaImage = ({ image = defaultImage }: Props) => (
  <Helmet>
    <meta property="og:image" content={image} />
  </Helmet>
);
